<template>
  <WorkflowNode class="icon-bg">
    <template v-if="trigger" #icon>
      <WdsIcon :name="trigger.icon" :size="24" weight="thin" color="#5D36F1" />
    </template>
    <template #title>
      <WdsStack justify-space-between align-start class="tw-w-full">
        <WdsStack direction-column>
          <WdsText large>{{ workflow.name }}</WdsText>
          <WdsText v-if="trigger" sm secondary>{{ trigger.label }}</WdsText>
        </WdsStack>
        <WdsButtonIcon
          data-test="open-workflow-meta-editor-button"
          sm
          class="tw-pl-3"
          @click="edit = true"
        >
          <WdsIcon name="edit" :size="16" />
        </WdsButtonIcon>
      </WdsStack>
    </template>
    <WdsText secondary class="tw-mt-1">
      {{ workflow.description }}
    </WdsText>
  </WorkflowNode>
  <teleport to="body">
    <WdsModal :title="$t('Update workflow details')" :show="edit" @cancel="edit = false">
      <WorkflowMetaEditor
        v-model="workflow"
        @cancel="edit = false"
        @submitted="edit = false"
        @error="edit = false"
      />
    </WdsModal>
  </teleport>
</template>

<script setup lang="ts">
import { WdsText, WdsIcon, WdsStack, WdsModal, WdsButtonIcon } from '@worksome/wds-components'
import { ref } from 'vue'
import { useVModel } from '@vueuse/core'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import WorkflowNode from '@/components/Workflows/Pages/Editor/Nodes/NodeComponent.vue'
import { Workflow } from '@/components/Workflows/Pages/Workflow/workflow'
import WorkflowMetaEditor from '@/components/Workflows/Pages/Workflow/WorkflowMetaEditor.vue'
import { triggerOptions } from '@/components/Workflows/utils'

const emit = defineEmits(['update:modelValue'])

const props = defineProps<{
  modelValue: Workflow
}>()

const edit = ref(false)
const workflow = useVModel(props, 'modelValue', emit)
const trigger = triggerOptions.find(({ value }) => value === workflow.value.trigger)
</script>

<style lang="scss" scoped>
.icon-bg {
  :deep(.icon-highlight) {
    background-color: #f3f0ff;
  }
}
</style>
